<template>
    <div>
    <v-layout wrap justify-center align-center>
        <v-flex md7 sm7 xs12>
            <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
        </v-flex>
    </v-layout>
    <v-layout wrap row justify-center align-center text-xs-center mt-1 pb-4 class="cont_page" :class="{'noclick': noclick}">
      <v-flex xs12 md7 sm7 class="cont">
        <v-layout row justify-center align-center>
          <v-flex xs6 text-xs-center class="subcont-left">
            <div class="cont-titulo"><h2>Com som de I</h2></div>

              <div v-for="(dropItem, index) in dropListUno" :key="'item'+index">
              <draggable v-model="dropListUno[index]" @change="change($event, index , correctoUno, dropListUno, dragList, retroaliment, retroClassA, tcorrectasA)" 
              :options="{group:{ name:'itemsgroup', put:retroaliment[index]}}" class="cont-drop" > 
                <p v-for="element in dropListUno[index]" :key="element" ><span v-html="element" :class="retroClassA[index]"></span></p>
              </draggable>
              </div>
              
          </v-flex>
          <v-flex xs6 text-xs-center class="subcont-right">
            <div class="cont-titulo"><h2>Com som de E</h2></div>

              <div v-for="(dropItem, index) in dropListDos" :key="'item'+index">
              <draggable v-model="dropListDos[index]" @change="change($event, index , correctoDos, dropListDos, dragList, retroalimentDos, retroClassB, tcorrectasB)" 
              :options="{group:{ name:'itemsgroup', put:retroalimentDos[index]}}" class="cont-drop" > 
                <p v-for="element in dropListDos[index]" :key="element" ><span v-html="element" :class="retroClassB[index]"></span></p>
              </draggable>
              </div>
              
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- inferior -->
      <v-flex xs12 md7 sm7 class="cont">
        <v-layout row justify-center align-center>
          <v-flex xs6 text-xs-center class="subcont-left">
            <div class="cont-titulo h-mas"><h2>Com som de [ch]</h2></div>

              <div v-for="(dropItem, index) in dropListTres" :key="'item'+index" class="item-drop">
              <draggable v-model="dropListTres[index]" @change="change($event, index , correctoTres, dropListTres, dragList, retroalimentTres, retroClassC, tcorrectasC)" 
              :options="{group:{ name:'itemsgroup', put:retroalimentTres[index]}}" class="cont-drop" > 
                <p v-for="element in dropListTres[index]" :key="element" ><span v-html="element" :class="retroClassC[index]"></span></p>
              </draggable>
              </div>

          </v-flex>
          <v-flex xs6 text-xs-center class="subcont-right">
            <div class="cont-titulo h-mas"><h2>Com som de [dyi]</h2></div>

              <div v-for="(dropItem, index) in dropListCuatro" :key="'item'+index">
              <draggable v-model="dropListCuatro[index]" @change="change($event, index , correctoCuatro, dropListCuatro, dragList, retroalimentCuatro, retroClassD, tcorrectasD)" 
              :options="{group:{ name:'itemsgroup', put:retroalimentCuatro[index]}}" class="cont-drop" > 
                <p v-for="element in dropListCuatro[index]" :key="element" ><span v-html="element" :class="retroClassD[index]"></span></p>
              </draggable>
              </div>

          </v-flex>
        </v-layout>
      </v-flex>
      <!-- inferior  2-->
      <v-flex xs12 md7 sm7 class="cont">
        <v-layout row justify-center align-center>
          <v-flex xs12 text-xs-center class="">
            <div class="cont-titulo"><h2>Com som de [dyi] final</h2></div>

              <div v-for="(dropItem, index) in dropListCinco" :key="'item'+index">
              <draggable v-model="dropListCinco[index]" @change="change($event, index , correctoCinco, dropListCinco, dragList, retroalimentCinco, retroClassE, tcorrectasE)" 
              :options="{group:{ name:'itemsgroup', put:retroalimentCinco[index]}}" class="cont-drop" > 
                <p v-for="element in dropListCinco[index]" :key="element" ><span v-html="element" :class="retroClassE[index]"></span></p>
              </draggable>
              </div>

          </v-flex>
        </v-layout>
      </v-flex>
      <!-- cont drag -->
      <v-flex xs12 sm7 md7 mt-2>
        <v-card flat tile color="transparent" class="cont-drags"  v-show="mostrarbotones">
          <v-card-actions class="cont-btn-nextprev">
            <div class="btn-slide-prev hvr" fab small @click="prev">
              <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
            </div>
            <div class="btn-slide-next hvr" fab small @click="next">
              <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
            </div>
          </v-card-actions> 
          <v-window v-model="onboarding" >
            <!-- draggables -->
            <draggable v-model="dragList" :options="{group:'itemsgroup'}" @start="saveEl">
              <v-window-item v-for="(element, index) in dragList" :key="index" >
                <div class="btn-drag hvr" :class="'animated bounceIn dura-'+element+''"  >
                  <p class="elemento" >{{element}}</p> 
                </div>
              </v-window-item>
            </draggable>
          </v-window>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal Resultado -->
    <modal-resultado-app v-model="modalResultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()" @malAvanzar="malAction()">
    </modal-resultado-app>
    <audio-player ref="audioPlayer" :autoplay="false" :audios="['slide15/Politica','slide15/Mente','slide15/Doce','slide15/Dicas','slide15/Adiantar','slide15/Cafe','slide15/Voce','slide15/Saudade','slide15/Felicidade','slide15/Civis']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'

export default {
  mixins: [nextConditions],
  components: {
      draggable,
  },
  data() {
    return {
      dialogos: [
        'Relacione a palavra ao caso correto e clique em avançar.'
      ],
        modalResultado:false,
        onboarding: 0,
        modalResult: 'bien',
        dragList: [
        'política', 
        'mente',
        'doce',
        'dicas', 
        'adiantar',
        'café', 
        'você',
        'saudade', 
        'felicidade',
        'civis', 
        ],
        vectoroObj: [  
            {palabra:'política', audio: 0}, 
            {palabra:'mente', audio: 1}, 
            {palabra:'doce', audio: 2}, 
            {palabra:'dicas', audio: 3}, 
            {palabra:'adiantar', audio: 4}, 
            {palabra:'café', audio: 5}, 
            {palabra:'você', audio: 6}, 
            {palabra:'saudade', audio: 7}, 
            {palabra:'felicidade', audio: 8},
            {palabra:'civis', audio: 9},
        ],
        dropListUno:Array(2).fill([]),
        dropListDos:Array(2).fill([]),
        dropListTres:Array(2).fill([]),
        dropListCuatro:Array(2).fill([]),
        dropListCinco:Array(2).fill([]),
        correctoUno:[
          'civis', 'doce'
        ],
         correctoDos:[
          'café', 'você'
        ],
         correctoTres:[
          'política', 'mente'
        ],
         correctoCuatro:[
          'dicas', 'adiantar'
        ],
         correctoCinco:[
          'saudade', 'felicidade'
        ],
        noclick:true,
        currentText:0,
        retroaliment:Array(2).fill(true),
        retroalimentDos:Array(2).fill(true),
        retroalimentTres:Array(2).fill(true),
        retroalimentCuatro:Array(2).fill(true),
        retroalimentCinco:Array(2).fill(true),
        retroClassA:Array(2).fill('inco'),
        retroClassB:Array(2).fill('inco'),
        retroClassC:Array(2).fill('inco'),
        retroClassD:Array(2).fill('inco'),
        retroClassE:Array(2).fill('inco'),
        vistos:Array(10).fill(false),
        countCorrecto:0,
        mostrarbotones:true,
        iguales:true,
        tcorrectasA:Array(2).fill(false),
        tcorrectasB:Array(2).fill(false),
        tcorrectasC:Array(2).fill(false),
        tcorrectasD:Array(2).fill(false),
        tcorrectasE:Array(2).fill(false),
    }
  },
   watch: {
    onboarding(){/*
      if(this.onboarding == 0){
        this.$refs.audioPlayer.playAudio((0))
      }
      if(this.onboarding == 1){
        this.$refs.audioPlayer.playAudio((1))
      }
      if(this.onboarding == 2){
        this.$refs.audioPlayer.playAudio((2))
      }
      if(this.onboarding == 3){
        this.$refs.audioPlayer.playAudio((3))
      }
      if(this.onboarding == 4){
        this.$refs.audioPlayer.playAudio((4))
      }
      if(this.onboarding == 5){
        this.$refs.audioPlayer.playAudio((5))
      }
      if(this.onboarding == 6){
        this.$refs.audioPlayer.playAudio((6))
        this.$store.commit('nextShow', true);
        
      }*/
    }
  },

  methods: {
    next () {
      this.onboarding = this.onboarding + 1 === this.length
        ? 0
        : this.onboarding + 1    
    },
    prev () {
      this.onboarding = this.onboarding - 1 < 0
        ? this.length - 1
        : this.onboarding - 1
    },
    saveEl(ev) {
        console.log('start ' + ev.item.innerHTML)
    },
    reproducirAudio(audioPosition){
        this.$refs.audioPlayer.playAudio(audioPosition)
    },
    change(ev, slotNum, arrayCorrectas, arrayDrop, arrayDrag, retro, retroclass, tcorrectas) {
          this.tcorrectasA = Array(2).fill(false)
          this.tcorrectasB = Array(2).fill(false)
          this.tcorrectasC = Array(2).fill(false)
          this.tcorrectasD = Array(2).fill(false)
          this.tcorrectasE = Array(2).fill(false)
          
        for (let i = 0; i < arrayCorrectas.length; i++) {
          if(arrayDrop[slotNum] != arrayCorrectas[i]){
             this.$set(tcorrectas,i,true)
          }else{
            this.$set(retro,slotNum,false)
            this.next()
            retroclass[slotNum] = 'bien'
            this.countCorrecto += 1
            this.$set(this.vistos,this.countCorrecto-1,true)
            console.log(this.vistos)
            
            //this.reproducirAudio(this.vectoroObj.palabra.indexOf(arrayDrop[slotNum]).audio)
          }
          for (let i = 0; i < this.vectoroObj.length; i++) {
            if ( this.vectoroObj[i].palabra == arrayDrop[slotNum]) {
              this.reproducirAudio( this.vectoroObj[i].audio)
            }            
          }
        }
        var todosVis = tcorrectas.every(el => {return el})
        if(todosVis) {
          arrayDrag.push(ev.added.element)
          retroclass[slotNum] = 'inco animated fadeOut dura-1'
          setTimeout(() => {
            this.$set(arrayDrop,slotNum,'')
            this.prev()
          },1000);
        }
        if(this.countCorrecto == 10){
          this.mostrarbotones = false
          this.modalResultado = true
          this.modalResult = 'bien'
        }
          
      },
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';
.cont{
  border: #D37A1C solid 3px;
  border-radius: 10px;
  height: auto;
}
.cont-titulo{
  font-family: Poppins-Bold;
  border-bottom: #D37A1C solid 3px;
  height: 20px;
  h2{
    margin: 0;
    padding: 0;
    font-size: 13px;
  }
}

.subcont-left{
  border-right: #D37A1C solid 1.5px;
}
.subcont-right{
  border-left: #D37A1C solid 1.5px;
}
.cont-drop{
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
    p{
    margin: 0;
    padding: 10px;
    font-family: Poppins-Regular;
    font-size: 15px;
  }
}
.h-mas{
  height: 45px;
}
.btn-drag{
  width: 100px;
  margin: 0 auto;
}
.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  padding: 12px;
  top: 20%;
  .btn-slide-next{
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
    z-index: 2;
  }
}
.titulo{
  font-size: 17px;
}
.sub-title {
    padding-top: 5px;
    font-size: 0.7rem;
    height: 66px;
}
.elemento {
  background: #0067AD;
  color: white;
  padding: 7px;
  border-radius: 10px;
  font-size: 14px;
}


.inco{
  color: red!important;
}
.bien{
  color: green!important;
}

</style>
